import { Footprints, PersonStanding, Store, Trophy, HeartHandshake, Heart } from "lucide-react";

/**
 * Big, bold, repeated CTA strip. Drop into any part of the landing page.
 * Renders differently depending on `variant` so the same block can be reused
 * without looking repetitive.
 */
export default function CTAStrip({ variant = "primary", onRegister, onVendor, onSponsor, onVolunteer, onDonate }) {
  const items = [
    { key: "5k", label: "Register 5K Run/Walk", icon: Footprints, color: "#00A651", onClick: onRegister },
    { key: "1mile", label: "Register 1-Mile Fun Run", icon: PersonStanding, color: "#EC008C", onClick: onRegister },
    { key: "vendor", label: "Become a Vendor", icon: Store, color: "#00A651", onClick: onVendor },
    { key: "sponsor", label: "Become a Sponsor", icon: Trophy, color: "#EC008C", onClick: onSponsor },
    { key: "volunteer", label: "Volunteer", icon: HeartHandshake, color: "#00A651", onClick: onVolunteer },
    { key: "donate", label: "Donate", icon: Heart, color: "#EC008C", onClick: onDonate },
  ];

  const isBanner = variant === "banner";

  return (
    <section
      data-testid={`section-cta-${variant}`}
      className={`relative border-y border-[#27272A] ${isBanner ? "bg-gradient-to-r from-[#00A651]/15 via-black to-[#EC008C]/15" : "bg-[#0A0A0A]"} py-12 md:py-16`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-6">
          <div className="text-[11px] uppercase tracking-[0.3em] text-[#EC008C] font-bold mb-2">
            Every Mile Empowers an Entrepreneur
          </div>
          <h3 className="font-display text-3xl md:text-4xl lg:text-5xl font-black uppercase tracking-tight text-white">
            Run. Walk. <span className="text-[#EC008C]">Bubble.</span> <span className="text-[#00A651]">Empower.</span>
          </h3>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
          {items.map(({ key, label, icon: Icon, color, onClick }) => {
            return (
              <button
                key={key}
                onClick={onClick}
                type="button"
                data-testid={`cta-${variant}-${key}`}
                className="group relative flex flex-col items-center justify-center gap-2 p-4 md:p-5 bg-[#141414] border-2 hover:-translate-y-1 transition-all duration-200 font-bold uppercase tracking-widest text-[10px] md:text-xs text-center min-h-[110px] md:min-h-[130px]"
                style={{ borderColor: color, color }}
              >
                <span
                  className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity"
                  style={{ background: color }}
                />
                <span className="relative flex flex-col items-center gap-2 group-hover:text-black transition-colors">
                  <Icon className="w-6 h-6 md:w-7 md:h-7" />
                  <span>{label}</span>
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}
